/**
 * Admin Portal Hints
 *
 * Contextual hints for the admin/platform portal.
 * Targets elements tagged with `data-astor-id` on admin portal pages.
 */

import type { HintConfig } from './hint-config.types';

export const adminPortalHints: HintConfig[] = [
  {
    id: 'admin-businesses-table',
    targetAstorId: 'admin-businesses-table',
    title: 'hints.admin.businesses.title',
    description: 'hints.admin.businesses.description',
    portal: 'admin',
    route: '/businesses',
    showOnce: true,
    priority: 'high',
    variant: 'info',
    placement: 'bottom',
  },
  {
    id: 'admin-users-management',
    targetAstorId: 'admin-users-page',
    title: 'hints.admin.users.title',
    description: 'hints.admin.users.description',
    portal: 'admin',
    route: '/users',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'admin-system-health',
    targetAstorId: 'admin-system-health',
    title: 'hints.admin.systemHealth.title',
    description: 'hints.admin.systemHealth.description',
    portal: 'admin',
    route: '/control-tower',
    showOnce: true,
    priority: 'medium',
    variant: 'info',
    placement: 'bottom',
  },
  {
    id: 'admin-dashboard-overview',
    targetAstorId: 'admin-dashboard-page',
    title: 'hints.admin.dashboard.title',
    description: 'hints.admin.dashboard.description',
    portal: 'admin',
    route: '/dashboard',
    showOnce: true,
    priority: 'high',
    variant: 'info',
    placement: 'bottom',
  },
  {
    id: 'admin-tenants-management',
    targetAstorId: 'admin-tenants-page',
    title: 'hints.admin.tenants.title',
    description: 'hints.admin.tenants.description',
    portal: 'admin',
    route: '/tenants',
    showOnce: true,
    priority: 'high',
    variant: 'tip',
    placement: 'bottom',
  },
  {
    id: 'admin-platform-overview',
    targetAstorId: 'platform-overview-page',
    title: 'hints.admin.platformOverview.title',
    description: 'hints.admin.platformOverview.description',
    portal: 'admin',
    route: '/platform',
    showOnce: true,
    priority: 'high',
    variant: 'info',
    placement: 'bottom',
  },
  {
    id: 'admin-platform-architecture',
    targetAstorId: 'platform-architecture-page',
    title: 'hints.admin.platformArchitecture.title',
    description: 'hints.admin.platformArchitecture.description',
    portal: 'admin',
    route: '/platform/architecture',
    showOnce: true,
    priority: 'medium',
    variant: 'info',
    placement: 'right',
  },
  {
    id: 'admin-platform-personas',
    targetAstorId: 'platform-personas-page',
    title: 'hints.admin.platformPersonas.title',
    description: 'hints.admin.platformPersonas.description',
    portal: 'admin',
    route: '/platform/personas',
    showOnce: true,
    priority: 'medium',
    variant: 'info',
    placement: 'right',
  },
  {
    id: 'admin-platform-workflows',
    targetAstorId: 'platform-workflows-page',
    title: 'hints.admin.platformWorkflows.title',
    description: 'hints.admin.platformWorkflows.description',
    portal: 'admin',
    route: '/platform/workflows',
    showOnce: true,
    priority: 'medium',
    variant: 'tip',
    placement: 'right',
  },
];
